export default __webpack_public_path__ + "static/media/WISE programs_Accelerator high res.749180a3.png";